import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

import type {
  DeleteSubscriptionMutation,
  DeleteSubscriptionMutationVariables,
} from './__generated__/useUnsubscribe.graphql.ts';

const DELETE_SUBSCRIPTION_MUTATION = gql`
  mutation DeleteSubscriptionMutation($input: deleteSubscriptionInput!) {
    deleteSubscription(input: $input) {
      subscription {
        slug
        anySubscribable {
          slug
          subscriptionsCount
          currentUserSubscription {
            slug
          }
          ... on User {
            slug
            followersCount
            followed {
              slug
            }
          }
        }
        subscriber {
          ... on CurrentUser {
            slug
            followingCount
          }
        }
      }
    }
  }
` as TypedDocumentNode<
  DeleteSubscriptionMutation,
  DeleteSubscriptionMutationVariables
>;
export const useUnsubscribe = (refetchQueries?: string[]) => {
  const [unsubscribe] = useMutation(DELETE_SUBSCRIPTION_MUTATION);

  return async (subscription: { slug: string }) =>
    unsubscribe({
      variables: {
        input: {
          slug: subscription.slug,
        },
      },
      refetchQueries,
    });
};
